import React, { PureComponent } from "react";
import { connect } from "react-redux";

import _ from "i18n";
import { setCurrentEmailCampaignData } from "actions";
import TTPSelect from "common/TTPSelect";
import { USER_ROLE_TYPES, USER_ROLE_TYPE_STATUS } from "Common";

@connect((store) => ({
  uaFilters: store.currentCampaign.email.uaFilters,
  recipientType: store.currentCampaign.email.recipientType,
}))
export default class CollaboratorFilters extends PureComponent {
  constructor(props) {
    super(props);

    this.roleTypeOptions = USER_ROLE_TYPES.map((role) => ({
      id: role,
      label: _(role).toUpperCase(),
    }));
    this.roleTypeStatusOptions = USER_ROLE_TYPE_STATUS.map((role) => ({
      id: role,
      label: _(role).toUpperCase(),
    }));
  }
componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.uaFilters != prevProps.uaFilters) {
      this.props.handleSetIsFilterChanged();
    }
  }
  handleChangeRoleType = (selectedIds) => {
    const { dispatch, recipientType, uaFilters } = this.props;

    let updatedFilterSelection;

    const existingFilterObjectIndex = uaFilters.findIndex(
      (filter) => filter.type === recipientType,
    );

    if (existingFilterObjectIndex !== -1) {
      updatedFilterSelection = [...uaFilters];
      updatedFilterSelection[existingFilterObjectIndex].roleType = selectedIds;
    } else {
      const newFilterObject = {
        type: recipientType,
        roleType: selectedIds,
        allowedGroups: [],
        deniedGroups: [],
      };
      updatedFilterSelection = [...uaFilters, newFilterObject];
    }

    dispatch(
      setCurrentEmailCampaignData({
        uaFilters: updatedFilterSelection,
      }),
    );

   
      this.props.handleSetIsFilterChanged();
    
  };

  handleChangeRoleTypeStatus = (selectedIds) => {
    const { dispatch, recipientType, uaFilters } = this.props;

    let updatedFilterSelection;

    const existingFilterObjectIndex = uaFilters.findIndex(
      (filter) => filter.type === recipientType,
    );

    if (existingFilterObjectIndex !== -1) {
      updatedFilterSelection = [...uaFilters];
      updatedFilterSelection[existingFilterObjectIndex].roleTypeStatus = selectedIds;
    } else {
      const newFilterObject = {
        type: recipientType,
        roleTypeStatus: selectedIds,
        allowedGroups: [],
        deniedGroups: [],
      };
      updatedFilterSelection = [...uaFilters, newFilterObject];
    }

    dispatch(
      setCurrentEmailCampaignData({
        uaFilters: updatedFilterSelection,
      }),
    );

   
      this.props.handleSetIsFilterChanged();
    
  };

  render() {
    const { uaFilters, recipientType } = this.props;

    const recipientFilter = uaFilters.find((f) => f.type === recipientType) || {};

    // Les valeurs sélectionnées doivent être des tableaux d'ids (strings)
    const roleTypeSelected = Array.isArray(recipientFilter.roleType)
      ? recipientFilter.roleType
      : [];
    const roleTypeStatusSelected = Array.isArray(recipientFilter.roleTypeStatus)
      ? recipientFilter.roleTypeStatus
      : [];

    return (
      <div className="row">
        <div className="columns small-6 columns-padding">
          <span className="tab-label">{_("ROLES_TYPES")}</span>
          <div className="small-12 m-r-xs">
            <TTPSelect
              values={roleTypeSelected}
              placeholder={_("Select role")}
              options={this.roleTypeOptions}
              onChange={this.handleChangeRoleType}
              notClearable={true}
              multi={true}
            />
          </div>
        </div>
        <div className="columns small-6 columns-padding">
          <span className="tab-label">{_("ROLES_STATUS")}</span>
          <div className="small-12">
            <TTPSelect
              values={roleTypeStatusSelected}
              placeholder={_("Select role status")}
              options={this.roleTypeStatusOptions}
              onChange={this.handleChangeRoleTypeStatus}
              notClearable={true}
              multi={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
